import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { Team } from "types";
import { TemplateDisplay } from "../DisplayTemplate";

export const SettingsTeamTemplate = ({ team }: { team: Team }) => {
    const [template, setTemplate] = useState<any | null>(null);
    const fetchTemplate = async () => {
        const response = await fetch(`__SITE_BASE__/api/teams/${team.id}/template`);
        const data = await response.json();
        setTemplate(data.template);
    };

    useEffect(() => {
        fetchTemplate();
    }, []);

    const createTemplate = async () => {
        const response = await fetch(`__SITE_BASE__/api/teams/${team.id}/template`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({}),
        });
        fetchTemplate();
        return response.json();
    };

    const deleteTemplate = async () => {
        const response = await fetch(`__SITE_BASE__/api/teams/${team.id}/template`, {
            method: "DELETE",
        });
        fetchTemplate();
        return response.json();
    };

    const shareTemplate = () => {
        if (template) {
            navigator.clipboard.writeText(window.location.origin + "/template/" + template.code);
            toast.success("Template copied to clipboard");
        }
    };

    return (
        <div className="flex flex-col items-start w-full focus:outline-none space-y-6 p-6 bg-brand-darkest rounded-lg shadow-lg">
            <div className="flex flex-col items-start gap-4 w-full">
                <h1 className="text-white text-3xl font-bold">Template</h1>
                <p className="text-gray-300">
                    A template is a way to quickly create a new team with the same settings as an existing team. You can create a template from this team, and then use it to create a new team with the same settings.
                </p>
                <div className="bg-brand-dark rounded-lg w-full p-6">
                    <div className="sm:flex space-y-2 sm:space-y-0 justify-between w-full">
                        <div className="text-white">
                            <h2 className="text-xl font-semibold">Template will copy:</h2>
                            <ul className="list-disc list-inside">
                                <li>Channels</li>
                                <li>Emojis</li>
                                <li>Roles</li>
                            </ul>
                        </div>
                        <div className="text-white">
                            <h2 className="text-xl font-semibold">Template will not copy:</h2>
                            <ul className="list-disc list-inside">
                                <li>Members</li>
                                <li>Bans</li>
                                <li>Invites</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="flex items-center gap-4 w-full">
                    {template ? (
                        <>
                            <TemplateDisplay template={template} team={team}>
                                <button
                                    className="text-white font-semibold hover:bg-gradient-to-r hover:from-green-400 hover:to-green-600 transition-all duration-300 px-4 py-2 bg-gradient-to-r from-green-500 to-green-700 rounded-lg text-sm"
                                >
                                    Display Template
                                </button>
                            </TemplateDisplay>
                            <button
                                onClick={shareTemplate}
                                className="text-white font-semibold hover:bg-gradient-to-r hover:from-blue-400 hover:to-blue-600 transition-all duration-300 px-4 py-2 bg-gradient-to-r from-blue-500 to-blue-700 rounded-lg text-sm"
                            >
                                Share Template
                            </button>
                            <button
                                onClick={deleteTemplate}
                                className="text-white font-semibold hover:bg-gradient-to-r hover:from-red-400 hover:to-red-600 transition-all duration-300 px-4 py-2 bg-gradient-to-r from-red-500 to-red-700 rounded-lg text-sm"
                            >
                                Delete Template
                            </button>
                        </>
                    ) : (
                        <button
                            onClick={createTemplate}
                            className="text-white font-semibold hover:bg-brand-green/50 transition-all duration-300 px-4 py-2 bg-brand-green rounded-lg text-sm"
                        >
                            This team has no template yet. Create one
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};